document.addEventListener('DOMContentLoaded', () => {
    const video = document.getElementById('hero-video');
    const btn = document.getElementById('video-sound-toggle');
    const icon = document.getElementById('video-sound-icon');
    const hint = document.querySelector('.pulse.z-10');

    if (!video || !btn || !icon) {
        return;
    }

    // Puls i 4 sekunder → fade bort automatiskt
    if (hint) {
        setTimeout(() => {
            hint.classList.add('fade-out');
        }, 4000);
    }

    btn.addEventListener('click', () => {
        video.muted = !video.muted;
        btn.setAttribute('aria-pressed', video.muted ? 'false' : 'true');

        if (video.muted) {
            icon.src =
                '/wp-content/themes/tankbar.com/static/images/volume-off.svg';
        } else {
            video.volume = 1;
            icon.src =
                '/wp-content/themes/tankbar.com/static/images/volume-up.svg';

            // Ta bort hint direkt när ljudet slås på
            if (hint) {
                hint.classList.add('fade-out');
            }
        }
    });
});